import { ReactElement, useContext } from 'react';
import MenuContext from 'contexts/menuContext';
import { SaveButtonContainer } from '../styles';
import { Button } from '~/components';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';

interface FloatSaveButtonProps {
  onClickSave: () => void;
  loading?: boolean;
}

function FloatSaveButton({
  onClickSave,
  loading,
}: FloatSaveButtonProps): ReactElement {
  const { t } = useTranslation();
  const { menuToogle } = useContext(MenuContext);

  return (
    <>
      {createPortal(
        <SaveButtonContainer menuToggle={menuToogle}>
          <Button
            onClick={onClickSave}
            variant="rc-blue"
            disabled={loading}
            style={{ textTransform: 'inherit' }}
          >
            {t('salvarAlteracoes')}
          </Button>
        </SaveButtonContainer>,
      document.querySelector('#root') as HTMLDivElement,
      )}
    </>
  );
}

export default FloatSaveButton;
